import { siteEntryUrl } from '../lib/qr';
import type { AssessmentModel, ResultTypeId, UiCopy } from '../lib/types';
import { CollectibleCard } from './CollectibleCard';

interface SharedResultProps {
  typeId: ResultTypeId;
  score: number;
  percentile: number;
  ui: UiCopy;
  model: AssessmentModel;
  onTakeTest: () => void;
}

export function SharedResult({
  typeId,
  score,
  percentile,
  ui,
  model,
  onTakeTest,
}: SharedResultProps) {
  // Level is derivable from the score, so the shared link never needs to carry it.
  const level = [...model.levels].reverse().find((entry) => score >= entry.min)
    ?? { id: 'beginner' as const, number: 1, min: 0 };

  return (
    <main className="result result-shared">
      <div className="result-stage">
        <CollectibleCard
          ui={ui}
          typeId={typeId}
          score={score}
          percentile={percentile}
          levelId={level.id}
          variant="shared"
          siteUrl={siteEntryUrl(window.location.href)}
        />
      </div>

      <div className="result-panel">
        {ui.shared.overline ? <p className="eyebrow">{ui.shared.overline}</p> : null}
        <h1 className="shared-title">{ui.shared.title}</h1>
        <button type="button" className="action-primary" onClick={onTakeTest}>
          {ui.shared.cta}
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </main>
  );
}
